export default {
  locations: {
    country: {
      france: 'France'
    },
    countrySubdivisionLevel1: {
      'auvergne-rhone-alpes': 'Auvergne-Rhône-Alpes',
      'bourgogne-franche-comte': 'Bourgogne-Franche-Comté',
      bretagne: 'Bretagne',
      corse: 'Corse',
      'centre-val-de-loire': 'Centre-Val de Loire',
      'grand-est': 'Grand Est',
      'hauts-de-france': 'Hauts-de-France',
      normandie: 'Normandie',
      'nouvelle-aquitaine': 'Nouvelle-Aquitaine',
      occitanie: 'Occitanie',
      'pays-de-la-loire': 'Pays de la Loire',
      'provence-alpes-cote-d-azur': "Provence-Alpes-Côte d'Azur",
      'ile-de-france': 'Île-de-France'
    },
    countrySubdivisionLevel2: {
      ain: 'Ain',
      aisne: 'Aisne',
      allier: 'Allier',
      'alpes-de-haute-provence': 'Alpes-de-Haute-Provence',
      'hautes-alpes': 'Hautes-Alpes',
      'alpes-maritimes': 'Alpes-Maritimes',
      ardeche: 'Ardèche',
      ardennes: 'Ardennes',
      ariege: 'Ariège',
      aube: 'Aube',
      aude: 'Aude',
      aveyron: 'Aveyron',
      'bouches-du-rhone': 'Bouches-du-Rhône',
      calvados: 'Calvados',
      cantal: 'Cantal',
      charente: 'Charente',
      'charente-maritime': 'Charente-Maritime',
      cher: 'Cher',
      correze: 'Corrèze',
      'cote-d-or': "Côte-d'Or",
      'cotes-d-armor': "Côtes-d'Armor",
      creuse: 'Creuse',
      dordogne: 'Dordogne',
      doubs: 'Doubs',
      drome: 'Drôme',
      eure: 'Eure',
      'eure-et-loir': 'Eure-et-Loir',
      finistere: 'Finistère',
      'corse-du-sud': 'Corse-du-Sud',
      'haute-corse': 'Haute-Corse',
      gard: 'Gard',
      'haute-garonne': 'Haute-Garonne',
      gers: 'Gers',
      gironde: 'Gironde',
      herault: 'Hérault',
      'ille-et-vilaine': 'Ille-et-Vilaine',
      indre: 'Indre',
      'indre-et-loire': 'Indre-et-Loire',
      isere: 'Isère',
      jura: 'Jura',
      landes: 'Landes',
      'loir-et-cher': 'Loir-et-Cher',
      loire: 'Loire',
      'haute-loire': 'Haute-Loire',
      'loire-atlantique': 'Loire-Atlantique',
      loiret: 'Loiret',
      lot: 'Lot',
      'lot-et-garonne': 'Lot-et-Garonne',
      lozere: 'Lozère',
      'maine-et-loire': 'Maine-et-Loire',
      manche: 'Manche',
      marne: 'Marne',
      'haute-marne': 'Haute-Marne',
      mayenne: 'Mayenne',
      'meurthe-et-moselle': 'Meurthe-et-Moselle',
      meuse: 'Meuse',
      morbihan: 'Morbihan',
      moselle: 'Moselle',
      nievre: 'Nièvre',
      nord: 'Nord',
      oise: 'Oise',
      orne: 'Orne',
      'pas-de-calais': 'Pas-de-Calais',
      'puy-de-dome': 'Puy-de-Dôme',
      'pyrenees-atlantiques': 'Pyrénées-Atlantiques',
      'hautes-pyrenees': 'Hautes-Pyrénées',
      'pyrenees-orientales': 'Pyrénées-Orientales',
      'bas-rhin': 'Bas-Rhin',
      'haut-rhin': 'Haut-Rhin',
      rhone: 'Rhône',
      'haute-saone': 'Haute-Saône',
      'saone-et-loire': 'Saône-et-Loire',
      sarthe: 'Sarthe',
      savoie: 'Savoie',
      'haute-savoie': 'Haute-Savoie',
      paris: 'Paris',
      'seine-maritime': 'Seine-Maritime',
      'seine-et-marne': 'Seine-et-Marne',
      yvelines: 'Yvelines',
      'deux-sevres': 'Deux-Sèvres',
      somme: 'Somme',
      tarn: 'Tarn',
      'tarn-et-garonne': 'Tarn-et-Garonne',
      var: 'Var',
      vaucluse: 'Vaucluse',
      vendee: 'Vendée',
      vienne: 'Vienne',
      'haute-vienne': 'Haute-Vienne',
      vosges: 'Vosges',
      yonne: 'Yonne',
      'territoire-de-belfort': 'Territoire de Belfort',
      essonne: 'Essonne',
      'hauts-de-seine': 'Hauts-de-Seine',
      'seine-saint-denis': 'Seine-Saint-Denis',
      'val-de-marne': 'Val-de-Marne',
      'val-d-oise': "Val-d'Oise",
      'polynesie-française': 'Polynésie française',
      'saint-barthelemy': 'Saint-Barthélemy',
      'saint-martin': 'Saint-Martin',
      'saint-pierre-et-miquelon': 'Saint-Pierre-et-Miquelon',
      'wallis-et-futuna': 'Wallis-et-Futuna',
      'nouvelle-caledonie': 'Nouvelle-Calédonie',
      guadeloupe: 'Guadeloupe',
      'la-reunion': 'La Réunion',
      mayotte: 'Mayotte',
      'terres-australes-françaises': 'Terres australes françaises',
      guyane: 'Guyane',
      martinique: 'Martinique'
    }
  },
  typeOrDistances: {
    triathlon: { label: 'Triathlon', key: 'TRIATHLON' },
    aquathlon: { label: 'Aquathlon', key: 'AQUATHLON' },
    duathlon: { label: 'Duathlon', key: 'DUATHLON' },
    'cross-triathlon': { label: 'Cross Triathlon', key: 'CROSS_TRIATHLON' },
    'triathlon-xs': { label: 'Triathlon XS', key: 'TRIATHLON_XS' },
    'triathlon-s': { label: 'Triathlon S', key: 'TRIATHLON_S' },
    'triathlon-m': { label: 'Triathlon M', key: 'TRIATHLON_M' },
    'triathlon-l': { label: 'Triathlon L', key: 'TRIATHLON_L' },
    'triathlon-xxl': { label: 'Triathlon XXL', key: 'TRIATHLON_XXL' },
    'pour-enfant': { label: 'Pour enfant', key: 'TRIATHLON_KIDS' },
    'ultra-triathlon': {
      label: 'Ultra-triathlon',
      key: 'ULTRA_TRIATHLON'
    },
    'run-&-bike': { label: 'Run & Bike', key: 'RUN_BIKE' },
    swimrun: { label: 'Swimrun', key: 'SWIM_RUN' },
    'swim-bike': { label: 'Swim Bike', key: 'SWIM_BIKE' },
    trail: { label: 'Trail', key: 'TRAIL' },
    running: { label: 'Running', key: 'RUNNING' },
    velo: { label: 'Vélo', key: 'CYCLING' },
    route: { label: 'Cyclosportive', key: 'GRAN_FONDO' },
    'ultra-cycling': { label: 'Ultra-cyclisme', key: 'ULTRA_CYCLING' },
    cross: { label: 'Cross', key: 'CROSS' },
    marche: { label: 'Marche', key: 'WALK' },
    'course-a-obstacles': {
      label: 'Course à obstacles',
      key: 'OBSTACLES_RACE'
    },
    'moins-de-5-km': { label: 'Moins de 5 km', key: 'LESS_THAN_5_KM' },
    '5-km': { label: '5 km', key: 'KM5' },
    '10-km': { label: '10 km', key: 'KM10' },
    '15-km': { label: '15 km', key: 'KM15' },
    '20-km': { label: '20 km', key: 'KM20' },
    'semi-marathon': { label: 'Semi-marathon', key: 'HALF_MARATHON' },
    marathon: { label: 'Marathon', key: 'MARATHON' },
    'ultra-running': { label: 'Ultra-running', key: 'ULTRA_RUNNING' },
    ekiden: { label: 'Ekiden', key: 'EKIDEN' },
    'trail-decouverte': {
      label: 'Trail découverte',
      key: 'DISCOVERY_TRAIL'
    },
    'trail-court': { label: 'Trail court', key: 'SHORT_TRAIL' },
    'trail-long': { label: 'Trail long', key: 'LONG_TRAIL' },
    'ultra-trail': { label: 'Ultra-trail', key: 'ULTRA_TRAIL' },
    'kilometre-vertical': {
      label: 'Kilomètre vertical',
      key: 'VERTICAL_KILOMETER'
    },
    'parcours-court': { label: 'Parcours court', key: 'SHORT_OBSTACLES' },
    'parcours-long': { label: 'Parcours long', key: 'LONG_OBSTACLES' },
    'randonnee-pedestre': { label: 'Randonnée pédestre', key: 'HIKING' },
    'marche-nordique': { label: 'Marche nordique', key: 'NORDIC_WALK' },
    fun: { label: 'Course fun', key: 'FUN' },
    'course-d-obstacle': {
      label: "Course d'obstacle",
      key: 'OBSTACLE_RACE'
    },
    'spartan-race': {
      label: 'Spartan Race',
      key: 'SPARTAN_RACE'
    },
    'color-run': {
      label: 'Color Run',
      key: 'COLOR_RUN'
    },
    'mud-day': {
      label: 'Mud Day',
      key: 'MUD_DAY'
    },
    autre: { label: 'Autre', key: 'OTHER' },
    'vol-libre': { label: 'Parapente', key: 'FREE_FLIGHT' },
    yoga: { label: 'Yoga', key: 'YOGA' },
    raid: { label: 'Raid', key: 'RAID' },
    'course-d-orientation': {
      label: "Course d'orientation",
      key: 'ORIENTEERING'
    },
    natation: { label: 'Natation', key: 'SWIMMING' },
    biathlon: { label: 'Biathlon', key: 'BIATHLON' },
    'ski-nordique--ski-de-fond': {
      label: 'Ski nordique, ski de fond',
      key: 'CROSS_COUNTRY_SKIING'
    },
    cyclosportive: { label: 'Cyclosportive', key: 'GRAN_FONDO' },
    'rando-velo-de-route': {
      label: 'Rando vélo de route',
      key: 'ROAD_CYCLING_TOUR'
    },
    cyclotourisme: { label: 'Cyclotourisme', key: 'CYCLE_TOURING' },
    'contre-la-montre': { label: 'Contre-la-montre', key: 'TIME_TRIAL' },
    bikepacking: { label: 'Bikepacking', key: 'BIKEPACKING' },
    'ultra-cyclisme': { label: 'Ultra-cyclisme', key: 'ULTRA_CYCLING' },
    'course-gravel': { label: 'Course Gravel', key: 'GRAVEL_RACE' },
    'rando-gravel': { label: 'Rando Gravel', key: 'GRAVEL_RIDE' },
    'rando-vtt': { label: 'Rando VTT', key: 'MOUNTAIN_BIKE_RIDE' },
    'vtt-cross-country': {
      label: 'VTT Cross Country',
      key: 'XC_MOUNTAIN_BIKE'
    },
    canicross: { label: 'Canicross', key: 'CANICROSS' },
    'vtt-enduro': { label: 'VTT Enduro', key: 'ENDURO_MOUNTAIN_BIKE' },
    hyrox: { label: 'Hyrox', key: 'HYROX' }
  },
  months: {
    janvier: 0,
    fevrier: 1,
    mars: 2,
    avril: 3,
    mai: 4,
    juin: 5,
    juillet: 6,
    aout: 7,
    septembre: 8,
    octobre: 9,
    novembre: 10,
    decembre: 11
  }
} as const
